import { ProductsApi } from '../api/products.api';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from './store';
import type { CustomerProduct } from '@recargas-dominicanas/core/types';

export const productSlice = createSlice({
  name: 'products',
  initialState: {
    loading: true,
    failed: false,
    products: [] as CustomerProduct[]
  },
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setFailed(state, action: PayloadAction<boolean>) {
      state.failed = action.payload;
    },
    setProducts(state, action: PayloadAction<CustomerProduct[]>) {
      state.products = action.payload;
    }
  }
});

const { setLoading, setFailed, setProducts } = productSlice.actions;

export function useProductStore() {

  const state = useAppSelector(state => state.products);
  const dispatch = useAppDispatch();

  async function fetch() {

    try {

      dispatch(setLoading(true));
      dispatch(setFailed(false));

      const products = await ProductsApi.getAll();

      dispatch(setProducts(products));
      dispatch(setLoading(false));

    } catch (err) {

      console.error(err);
      dispatch(setLoading(false));
      dispatch(setFailed(true));

    }
  }

  return {
    ...state,
    fetch
  };
}
